import {ThunkDispatch} from "@reduxjs/toolkit"
import { useNavigate, useLocation } from "react-router-dom"
import {useSelector, useDispatch } from "react-redux"
import {currentUserActions} from '../reducers/currentUser'
import { useEffect } from "react";
import CanNotAccess from "../pages/CanNotAccess";
import NotAllowIP from "../pages/NotAllowIP";
import { getTabId } from "../utils/util";
import useTrackPageView from "../hooks/useTrackPageView";
import { PERMISSION_MAPPING_URL } from '../constants/index';

interface  ProtectedPageType {
    children: any,
}

const ProtectedCompanyPage = (props: ProtectedPageType) => {
    const location = useLocation();
    const {children} = props as any
    const currentUser = useSelector((state: any) => state.currentUser)
    const {staffInfo, email, staffPermission} = currentUser

    useTrackPageView({ urlPath: "" });

    useEffect(() => {
      const tabId = getTabId();
      const channel = new BroadcastChannel("auth_channel");

      channel.onmessage = (event) => {
          const { type, sender } = event.data || {};

          if (type === "forceReload" && sender !== tabId) {
              window.location.reload();
          }
      };

      return () => {
          channel.close();
      };
    }, []);
    
    const navigate = useNavigate();
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
    useEffect(() => {
        dispatch(currentUserActions.getCurrentUser({navigate, view: 'company'}))
    }, [location]);

    // Check permission access page
    for(const item of PERMISSION_MAPPING_URL) {
      if(location.pathname.includes(item.url) && staffPermission && Object.entries(staffPermission).length > 0 && !staffPermission[item.permission]) {
        return <CanNotAccess />
      }
    }
    
    if (staffInfo) {
      if (staffInfo.is_company_expired) {
        return <CanNotAccess />
      } else if (staffInfo.is_allow_ip) {
        return children;
      } else {
        return <NotAllowIP />
      }
    }

    if(!staffInfo && email) {
      return <CanNotAccess />
    } 
    
    return null;
};

export default ProtectedCompanyPage
